import { render, staticRenderFns } from "./MemberManagePage.vue?vue&type=template&id=05365432&scoped=true&"
import script from "./MemberManagePage.vue?vue&type=script&lang=js&"
export * from "./MemberManagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05365432",
  null
  
)

export default component.exports